<template>
  <div>
    <el-dialog-zdy
      append-to-body
      title="学习进度"
      :visible.sync="dialogVisible"
      width="70%"
      @close="closeWin()"
      append-to-body
    >
      <el-table
        :data="detailListDtos"
        :height="bodyHeight - 200"
        style="width: 100%">
        <el-table-column prop="dataName" label="资料名称"></el-table-column>
        <el-table-column prop="totalHours" label="总学习时长(分)"></el-table-column>
        <el-table-column
          prop="totalHoursLearned"
          label="已学时长(分)"
        ></el-table-column>
        <el-table-column  label="操作">
          <template slot-scope="scope">
            <!-- <el-button size="mini" type="text" v-if="scope.row.trainingDetailListDtoList.length <= 1" @click="detailRow(scope.row)">考试记录</el-button> -->
            <el-button size="mini" type="text" @click="detailRow(scope.row)">考试记录</el-button>
            <el-button size="mini" type="text" v-if="scope.row.trainingDetailListDtoList.length > 1" @click="dataListDetailRow(scope.row)">测试列表</el-button>

          </template>
        </el-table-column>
      </el-table>
    </el-dialog-zdy>
    <record ref="record"></record>

    <courseware-video v-if="dataListDialogVisible" :detailId="detailId" @close="close()"  :dialogVisible.sync="dataListDialogVisible" :dataList="dataList"></courseware-video>


  </div>
</template>

<script>
import  Record from '@/components/classTestRecord/record.vue'
import  CoursewareVideo from '@/components/classTestRecord/courseware-video.vue'
import student from "@/api/new/student.js";
import studyProgress from "@/components/studyProgress";
import  API  from '@/api/yjt/api_class_test.js'
export default {
  components:{Record,CoursewareVideo},
  props: { id: Number },
  data() {
    return {
      bodyHeight: 0,
      dialogVisible: false,
      dataListDialogVisible:false,
      detailListDtos: [],
      dataList:[],
      detailId:undefined,
      detailInfo: null,
    };
  },
  methods: {
    closeWin() {
      console.log('this.colseWin')
      this.dataListDialogVisible=false;
      this.dialogVisible=false;
    },
    close(){
      this.dataListDialogVisible=false;
    },
    dataListDetailRow(row){
      this.dataListDialogVisible=true;
      this.dataList=row.trainingDetailListDtoList;
      console.log(row.trainingDetailListDtoList)
    },
    detailRow(row){
      console.log('detailRow', row);
      // let dataFrom={
      //   trainingDetailListId:this.detailId,
      //   // resourcesId: row.trainingResourcesId
      //   resourcesId: row.id || row.trainingResourcesId,
      // }
      // this.$refs.record.show(dataFrom,row.dataName);
      // API.queryList(dataFrom).then(res =>{
      //   console.log(res)
      // })
      this.$router.push({
        path: '/student/lookExam?id='+this.detailInfo.paperId+'&examDetailListId='+this.detailInfo.examDetailId,
      })

    },
    open(id) {
      this.detailId=id;
      this.dialogVisible = true;
      this.getTrainDetailList(id);
    },
    getTrainDetailList(id) {
      student
        .getRecordingTrainingDetail({
          detailId: id
        })
        .then(res => {
          this.detailInfo = res.data;
          this.detailListDtos = res.data.detailListDtos;
        });
    }
  },
  mounted() {
    this.bodyHeight = document.body.offsetHeight - 50;
    if(this.bodyHeight < 600) {
      this.bodyHeight = 600
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/studyProgress.vue